document.addEventListener('DOMContentLoaded', function () {
  var revealEls = document.querySelectorAll('.nexo-reveal, .nexo-reveal-scale, .nexo-reveal-clip, .nexo-stagger');
  if (revealEls.length && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    revealEls.forEach(function (el) {
      observer.observe(el);
    });
  } else {
    revealEls.forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  document.querySelectorAll('[data-nexo-countdown]').forEach(function (el) {
    var endsAt = new Date(el.getAttribute('data-nexo-countdown')).getTime();
    if (isNaN(endsAt)) return;

    function tick() {
      var now = Date.now();
      var diff = endsAt - now;
      if (diff <= 0) {
        el.textContent = el.getAttribute('data-expired-label') || 'Oferta finalizada';
        el.classList.add('is-expired');
        clearInterval(timer);
        return;
      }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      var parts = [];
      if (d > 0) parts.push(d + 'd');
      parts.push(String(h).padStart(2, '0') + 'h');
      parts.push(String(m).padStart(2, '0') + 'm');
      parts.push(String(s).padStart(2, '0') + 's');
      el.textContent = parts.join(' ');
    }
    tick();
    var timer = setInterval(tick, 1000);
  });

  // Shopify wraps each section as id="shopify-section-{template-id}__{section-key}",
  // and the template-id prefix varies per page — a literal "#shopify-section-main"
  // anchor never matches. Scroll to whichever section's id ends with the target key.
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-nexo-scroll-to]');
    if (!trigger) return;
    var key = trigger.getAttribute('data-nexo-scroll-to');
    var target = document.querySelector('[id$="__' + key + '"]');
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
});
